export default "__VITE_ASSET__Bvprg2Z___"